
import FooterComponent from './FooterComponent';
import { useEffect, useState } from 'react';
import DetailsPage from './DetailsPage';
import useBodyClass from "../UseBodyClass"
import { useScroll } from '../HelperRepository';
import DetailsHeaderComponent from './DetailsHeaderComponent';
import MainComponent from './MainComponent';
import SmallVideo from './SmallVideo';
import {useLocation, useParams} from "react-router-dom";
import configData from '../config.json';
import { getMediaAdditionalParameters } from '../fetchData/DataManager';

const BodyComponentDetails = ({ category,
    categoryList,
    activeCategory,
    setActiveCategory,
    setActiveVideo,
    activeVideo,
    setCategoryList,
    shouldLoad
}) => {

    let {cat, id} = useParams();

    const location = useLocation();

    const [activeVideoMetadata, setActiveVideoMetadata] = useState();
    const [canShow, setCanShow] = useState(false);

    useEffect(() => {

        var pathCat = (cat).replaceAll('-', ' ');
        var media;
        for (var j = 0; j < categoryList.length ; j++) {
            if(pathCat === categoryList[j].flatName) {
                if(categoryList[j].videos){
                    for (var i = 0; i < categoryList[j].videos.length; i++) {
                        if(categoryList[j].videos[i].id === id) {
                            media = categoryList[j].videos[i];
                            localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_VIDEO_URL, JSON.stringify(categoryList[j].videos[i].url));
                            localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_VIDEO, JSON.stringify(categoryList[j].videos[i]));
                            localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_CATEGORY, JSON.stringify(categoryList[j]));   
                            setActiveVideo(categoryList[j].videos[i]);
                            setActiveCategory(categoryList[j]);
                            break;
                        }
                        
                    }
                }
                break;
            }
         }
        
    }, [location]);

    useEffect(() => {

        var pathCat = (cat).replaceAll('-', ' ');
        var media;
        for (var j = 0; j < categoryList.length ; j++) {

            if(pathCat === categoryList[j].flatName) {
                if(categoryList[j].videos){
                    for (var i = 0; i < categoryList[j].videos.length; i++) {
                        if(categoryList[j].videos[i].id === id) {
                            media = categoryList[j].videos[i];

                            localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_VIDEO_URL, JSON.stringify(categoryList[j].videos[i].url));
                            localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_VIDEO, JSON.stringify(categoryList[j].videos[i]));
                            localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_CATEGORY, JSON.stringify(categoryList[j]));   
                            setActiveVideo(categoryList[j].videos[i]);
                            setActiveCategory(categoryList[j]);
                            break;
                        }
                        
                    }
                }
                break;
            }
         }

    }, [categoryList]);

    useEffect(() => {

        const fetchData = async () => {

          await getMediaAdditionalParameters(id);

        setActiveVideoMetadata(localStorage.getItem("activeVideoAdditionalMetadata"));
          if(JSON.parse(localStorage.getItem("activeVideoAdditionalMetadata")).id === id)
            setCanShow(true);
        }
      
        fetchData()
          .catch(console.error);
      })

    useEffect(() => {
        setActiveVideoMetadata(activeVideoMetadata);
    }, [activeVideoMetadata]);

    useScroll(shouldLoad);

    if((configData.BRAND).toUpperCase() === 'DELO'){
        useBodyClass([`d-video-delo`, `d-video-fullscreen`]);
        var imgSrcBrand = configData.DELO.LOGO;
        var altImgBrand = configData.DELO.ALTIMG;
        var imgClassNameBrand = "d-logo-header d-delo-logo";
    }
    else {
        useBodyClass([`d-video-novice`, `d-video-fullscreen`]);
        var imgSrcBrand = configData.SLOVENSKENOVICE.LOGO;
        var altImgBrand = configData.SLOVENSKENOVICE.ALTIMG;
        var imgClassNameBrand = "d-logo-header d-novice-logo";
    }
   

    return (
        <>
            <DetailsHeaderComponent categoryList={categoryList} setActiveCategory={setActiveCategory} activeCategory={activeCategory} setActiveVideo={setActiveVideo}>
                {shouldLoad && (
                    
                    <DetailsPage activeVideo={activeVideo}
                        activeCategory={activeCategory}
                        setActiveCategory={setActiveCategory}
                        setActiveVideo={setActiveVideo}
                        activeVideoMetadata={activeVideoMetadata}
                        canShow={canShow}
                    >
                    </DetailsPage>
                )}
            </DetailsHeaderComponent>
            <MainComponent shouldLoad={shouldLoad}>

            {shouldLoad && (
                <section id="videolist" className="d-section d-video-list">
                    <div className="container">
                    <div className="row mt-3 mb-4 py-1 d-delo-specific">
                            <div className="col" data-aos="fade-right" data-aos-delay="400">
                                <h2 className="d-category-title d-title-combined">Ostali nedavni videoposnetki v <span className="d-category">{activeCategory.name}</span></h2>
                                <div className="row"><div className="col-md-6">
                                    <p className="d-category-description">{activeCategory.description}</p>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="d-video-thumbnails-grid col d-grid">
                                {activeCategory.videos && activeCategory.videos.map((video) => (

                                    <SmallVideo key={video.id}
                                        video={video}
                                        activeCategory={activeCategory}
                                        setActiveCategory={setActiveCategory}
                                        setActiveVideo={setActiveVideo}
                                        fromPage='details'
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            )}
            </MainComponent>

            <FooterComponent categoryList={categoryList} setActiveCategory={setActiveCategory} setActiveVideo={setActiveVideo}></FooterComponent>

            {/* Preloader */}
            {!shouldLoad && (
                <div id="preloader" className="preloader d-bg-transparent-85">
                    <img src={imgSrcBrand} className={imgClassNameBrand} alt={altImgBrand}/>
                </div>
            )}
        </>
    );
};

export default BodyComponentDetails;